import { createContext } from 'react';

export type OnAcceptCallback = (data: { asset: { id: string } }) => void;

export interface ModalOptions {
  onAccept?: OnAcceptCallback;
}

export interface IPendingInvitationsModalContext {
  open: (options?: ModalOptions) => void;
  close: () => void;
}

export const PendingInvitationsModalContext = createContext<
  IPendingInvitationsModalContext | undefined
>(undefined);
